import { createContext, useContext } from 'react';

export interface SectionMessageContextValue {
  checkboxChecked?: boolean;
  setCheckboxChecked?: (checked: boolean) => void;
}

export const SectionMessageContext = createContext<SectionMessageContextValue>({});

export const useSectionMessageContext = () => {
  const context = useContext(SectionMessageContext);

  if (!context) {
    throw new Error('useSectionMessageContext must be used within a SectionMessageProvider');
  }

  return context; // null일 수 있음 (SectionMessage 외부에서 사용하는 경우)
};
